import { render } from "./workerIds.vue?vue&type=template&id=1e04ceec"
import script from "./workerIds.vue?vue&type=script&lang=js"
export * from "./workerIds.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__